<div class="title-grid">
    <img class="title-icon" [src]="'/assets/images/distribution-groups.svg'" />
    <h2 translate>grid.navs.approvals</h2>
</div>
<que-approvals-list *ngIf="!reportsTab$()"></que-approvals-list>
<que-reports-list *ngIf="reportsTab$()"></que-reports-list>